import { Injectable } from '@angular/core';
import { ShopAPI, ShopSettingsApi } from '@etop/api/shop/shop-settings.api';
import { ShopSettings } from '@etop/models/ShopSettings';

@Injectable({ providedIn: 'root' })
export class ShopSettingsService {

    constructor(private shopSettingsServiceApi: ShopSettingsApi) { }

    async getSetting(): Promise<ShopSettings> {
        return await this.shopSettingsServiceApi.getSetting();
    }

    async updateSetting(data) {
        return await this.shopSettingsServiceApi.updateSetting(data);
    }

    async getTelecomBalance(serviceClassify: 'telecom' | 'shipping') {
        const request: ShopAPI.CalcBalanceUserRequest = {
            service_classify: serviceClassify
        };
        const res = await this.shopSettingsServiceApi.calcShopBalance(request);
        return res.telecom_balance;
    }
}
